import type { CometDSingleton } from '$lib/services/cometd/cometd.js';
import { getJackpotsEventConverters } from './eventConverters/index';
import { CHANNELS } from '../../cometd/cometd.constants';
import type { TEvent } from '../../cometd/cometd.types';
import { spineBus } from '../MessageBus';
import type { TEventConverterPayloads } from './eventConverters/eventConverter.types';
import { cond } from 'lodash-es';

const subscriptionHandler = (event: TEvent) => {
    const conditions = getJackpotsEventConverters();

    const getPayload = cond<TEvent, TEventConverterPayloads>(conditions);
    const payload = getPayload(event);

    if (!payload) return;
    spineBus.publish('external', payload);
};

export const subscribeToJackpotsUpdates = (
    cometd: CometDSingleton | undefined,
    unsubscribe: VoidFunction = () => {}
): VoidFunction => {
    if (!cometd) {
        return unsubscribe;
    } else {
        const jackpotsHandlePromise = cometd.subscribe(CHANNELS.JACKPOTS, subscriptionHandler, {});
        return () =>
            jackpotsHandlePromise.then((jackpotsHandle) => cometd.unsubscribe(jackpotsHandle));
    }
};
